import {
  SET_LOADING, SET_MGMT_CONTRACT_NoS, SET_MGMT_CONTRACT_No, SET_MGMT_CONTRACT_NoS_TOTAL
} from "./mutations";
import ApiService from "@/core/services/ApiService";

export default {

  async fetchMgmtContractNos({ commit },  params = {}) {
    commit(SET_LOADING, true);

    ApiService.setHeader();
    return await ApiService.query("mgmt/contract_nos",params)
        .then((result) => {
          result =result.data;
          commit(SET_MGMT_CONTRACT_NoS, result?.data ?? []);
          commit(SET_MGMT_CONTRACT_NoS_TOTAL, result?.total ?? []);
          commit(SET_LOADING, false);

          return result;
        })
        .catch(({response}) => {
          // console.log('error response', response);
        });
  },
  async fetchMgmtContractNo({ commit }, params) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.get("mgmt/contract_nos", params)
        .then((result) => {
          result = result.data;
          commit(SET_CONTRACT_No, result ?? {});
          commit(SET_LOADING, false);
          return result;
        })
        .catch(({response}) => {
          // console.log('error response', response.data);
          commit(SET_CONTRACT_No, { success: false });
            return response.data;

        });
  },
  async createMgmtContractNo({ commit }, params) {
    commit(SET_LOADING, true, { root: true });
      ApiService.setHeader();
      return await ApiService.post("mgmt/contract_nos", params)
          .then((result) => {
              return result.data;
          })
          .catch(({response}) => {
              // console.log('error response', response);
              return response.data;
          });
  },
  async updateMgmtContractNo({ commit },params) {
    const id = params.proposal_id
    delete params.proposal_id
    commit(SET_LOADING, true);
      ApiService.setHeader();
      return await ApiService.put("mgmt/contract_nos/"+id, params)
          .then((result) => {
              return result.data;
          })
          .catch(({response}) => {
              // console.log('error response', response);
          });
  },
  async deleteMgmtContractNo({ commit }, params) {
    commit(SET_LOADING, true);
      ApiService.setHeader();
      return await ApiService.delete("mgmt/contract_nos/"+params)
          .then(async (result) => {
              // console.log('result',result.data)
              return result.data;

          })
          .catch((response) => {
              // console.log('delete error response', response);
          });
  },
};
